module.exports = __webpack_public_path__ + "img/valores.012c1d50.jpg";